<form [formGroup]="formGroup" class="form_style">
    <mat-form-field appearance="outline">
        <mat-label>{{this.title}}</mat-label>
        <mat-select [formControl]="this.formGroup.get(this.category)" multiple (selectionChange)="onChange($event)"
            [id]="this.category">
            <mat-option *ngFor="let i of values" [value]="i.value === undefined ? i : i.value">{{i.name === undefined ? i : i.name}}</mat-option>
        </mat-select>
    </mat-form-field>
</form>
